// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { WidgetChartTypeEnum, WidgetDonutOutput } from 'thehive-sdk';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';
import { DonutForm, DonutValues } from '@Organisms/Dashboard/WidgetManage/Donut/DonutForm';

export const getNewDonutWidget = (donut: DonutValues): WidgetDonutOutput => {
    const {
        title,
        entity,
        category,
        stacked = false,
        filters = [],
        periodDateField,
        sort,
        limit,
        customize,
        percentage = false,
        size = 0,
    } = donut;

    return {
        type: WidgetChartTypeEnum.donut,
        options: {
            title,
            entity,
            field: category,
            query: {},
            names: {},
            stacked,
            periodDateField,
            filters,
            sort,
            limit,
            customize,
            percentage,
            size,
        },
        id: '',
    };
};

const NewDonutDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewDonutWidget(values as DonutValues)}
        WidgetForm={DonutForm}
        widgetType="donut"
    />
);

export default NewDonutDrawer;
